import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { List } from "immutable";
import { ListItem } from "../../list/list-item";

@Component({
  selector: "app-grid-header-stats",
  templateUrl: "./grid-header-stats.component.html",
  styleUrls: ["./grid-header-stats.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridHeaderStatsComponent {
    @Input() gridHeaderStatistics = List<ListItem>();
    @Output() onClick = new EventEmitter<string>(true);
    @Input() selectedStat: string;

    constructor() { }

    applyStatisticsFilter(key: string): void {
        this.onClick.emit(key);
    }

    getClass(item: ListItem): string {
        return item.key === this.selectedStat ? "activeStats" : "";
    }

    trackByIndex(index, item) {
        return index;
    }

}
